import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import Select from '../form/Select';
import FlexGrid from '../layout/FlexGrid';

class Graph extends Component {
    state = {};

    render() {
        const { variant = 'two' } = this.props;
        const { children, title, value, modes, onModeChange, placeholder = 'Please select...' } = this.props;
        return (
            <div className={variant}>
                {(!!title || !!modes) && (
                    <div className="graph-title">
                        {!!title && <p>{title}</p>}
                        {!!modes && (
                            <Select
                                controlProps={{ style: { margin: 0 } }}
                                placeholder={placeholder}
                                fullWidth={false}
                                options={modes}
                                onChange={onModeChange}
                                value={value}
                            />
                )}
                    </div>
                )}
                <FlexGrid variant={'four' !== variant ? 'no-wrap' : 'full-height'}>{children}</FlexGrid>
            </div>
        );
    }
}

export default withStyles({})(Graph);
